import React, { useState, useEffect } from "react";
import { STRIPE_CLIENT_ID, API_ROOT } from "../../constants";
import { useSelector, useDispatch } from "react-redux";
import { Spinner } from "../../assets";
import axios from "axios";
import { errorResponse } from "../../helpers";
import { setSessionData } from "../../actions/session";

const stripeLink = `https://connect.stripe.com/express/oauth/authorize?client_id=${STRIPE_CLIENT_ID}&state=${"none"}`;

export default function StripeButton({ handlerUrl, onSuccess }) {

	const dispatch = useDispatch();
	const { query, token } = useSelector(state => state.session);
	const code = query.code;
	const [error, setError] = useState(null);
	const [stripeCode, setStripeCode] = useState(code);

	// Remove the code query from the session data so it doesn't get used again.
	useEffect(() => {
		if (code) dispatch(setSessionData({
			query: { ...query, code: null }
		}));
	}, [code, dispatch, query]);

	useEffect(() => {
		if (stripeCode) {
			setStripeCode(null);
			sendStripeCode(stripeCode, token, handlerUrl)
				.then(onSuccess).catch(error => {
					setError(error);
				});
		}
	}, [stripeCode, token, handlerUrl, dispatch, onSuccess]);

	return <>
		<button
			className="stripeButton"
			onClick={e => {
				if (stripeCode) return;
				window.open(`${stripeLink}&redirect_uri=${window.location.href}`);
			}}
			style={stripeCode ?
				{
					height: 44,
					padding: 10,
					cursor: "default"
				} : {
					cursor: "pointer"
				}
			}
		>
			{stripeCode ? <Spinner /> : "Set Up Stripe"}
		</button>
		{error && <div className="error text-center">{error}</div>}
	</>
}

function sendStripeCode(code, token, url) {
	return new Promise((resolve, reject) => {
		axios.get(`${API_ROOT}${url}`, {
			params: { code },
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
			.then(res => res.data)
			.then(resolve)
			.catch(error => reject(errorResponse(error)));
	});
}